import { render, staticRenderFns } from "./ListStructure.vue?vue&type=template&id=8b6d9142&"
import script from "./ListStructure.vue?vue&type=script&lang=js&"
export * from "./ListStructure.vue?vue&type=script&lang=js&"
import style0 from "./ListStructure.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8b6d9142')) {
      api.createRecord('8b6d9142', component.options)
    } else {
      api.reload('8b6d9142', component.options)
    }
    module.hot.accept("./ListStructure.vue?vue&type=template&id=8b6d9142&", function () {
      api.rerender('8b6d9142', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/customDocuments/components/ListStructure.vue"
export default component.exports